import { lazy, type JSX } from 'react';
import { Navigate, Route } from 'react-router-dom';
import { nhAppMainPages } from '@pflegenavi/frontend/routing';
import { DefaultSuspense } from '@pflegenavi/web-components';

const ReportingOverviewPage = lazy(() => import('./ReportingOverviewPage'));

export const reportingV3Routes = (): JSX.Element => {
  return (
    <Route path={nhAppMainPages.REPORTING_V3}>
      <Route
        index={true}
        element={<Navigate to={nhAppMainPages.REPORTING_V3_OVERVIEW} replace />}
      />
      <Route
        path={nhAppMainPages.REPORTING_V3_OVERVIEW}
        element={
          <DefaultSuspense>
            <ReportingOverviewPage />
          </DefaultSuspense>
        }
      />
    </Route>
  );
};
